<template>
    <div id="home" v-loading.fullscreen.lock="changeLoading">
      <Bannerheader v-on:childByValue="childByValue"></Bannerheader>
      <div v-if="tabName == '1'" style="background-color: white; margin: 10px 20px">
        <div class="pos_container_panel">
          <!--search area-->
          <el-form :inline="true">
            <el-row :gutter="10" class="content_size">
                <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-form-item :label="$t('BANNERINFO.ACTIVITENAME')" class="form-label-field">
                        <el-input v-model="serachParams.activiteName" autocomplete="off" class="myinput_inner"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-form-item :label="$t('BANNERINFO.STARTDATE')" class="form-label-field">
                        <el-date-picker type="date" v-model="serachParams.startDate" placeholder="yyyy/mm/dd" class="myinput_inner"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-form-item :label="$t('BANNERINFO.CREATEDBY')" class="form-label-field">
                        <el-input v-model="serachParams.createdBy" autocomplete="off" class="myinput_inner"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
                <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-form-item :label="$t('BANNERINFO.ACTIVITECODE')" class="form-label-field">
                        <el-input v-model="serachParams.activiteCode" autocomplete="off" class="myinput_inner"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-form-item :label="$t('BANNERINFO.ACTIVITESTATUS')" class="form-label-field">
                        <el-select v-model="serachParams.activiteStatus"  clearable style="width: 220px;" class="myinput_inner">
                          <el-option v-for="item in bannertypeoptions" :key="item.key" :label="item.value" :value="item.key">
                          </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-form-item class="form-label-field" style="float:right;">
                        <el-button type="warning" class="harpIDbtn" @click="addBanner()">{{$t('BANNERINFO.ADDBANNERMAINTAIN')}}</el-button>
                    </el-form-item>
                    <el-form-item class="form-label-field" style="float:right;">
                        <el-button type="warning" class="harpIDbtn" @click="adsSearch()">{{$t('BANNERINFO.SEARCH')}}</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
          </el-form>
          <hr style="margin: 1rem -14rem 3rem;background-color: rgb(241 243 245);height: 0.2rem;border: none;"/>
          <!--table-->
          <div>
            <Loading :loading="bannerloading" :isRelativeBrowserWin="false" />
            <el-main style="padding-top: 0; padding-bottom: 0">
              <el-table ref="orderListTable" :data="tableData" border :empty-text="$t('BANNERINFO.NoData')" width="100%">
                <el-table-column prop="activiteName"  align="center" :label="$t('BANNERINFO.ACTIVITENAME')" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="activiteCode"  align="center"  :label="$t('BANNERINFO.ACTIVITECODE')">
                </el-table-column>
                <el-table-column prop="createdBy"  align="center" :label="$t('BANNERINFO.CREATEDBY')">
                </el-table-column>
                <el-table-column prop="pageTypeValue"  align="center" :label="$t('BANNERINFO.PAGETYPE')">
                </el-table-column>
                <el-table-column prop="activiteStatus"  align="center" :label="$t('BANNERINFO.ACTIVITESTATUS')">
                </el-table-column>
                <el-table-column prop="createdDate"  align="center" :label="$t('BANNERINFO.CREATEDDATE')">
                </el-table-column>
                <el-table-column prop="startDate"  align="center" :label="$t('BANNERINFO.STARTDATE')">
                </el-table-column>
                <el-table-column prop="endDate"  align="center" :label="$t('BANNERINFO.ENDDATE')">
                </el-table-column>
                <el-table-column prop="remark"  align="center" :label="$t('BANNERINFO.REMARK')" show-overflow-tooltip>
                </el-table-column>
                <el-table-column  align="center" :label="$t('ORDERLIST.Operation')" fixed="right">
                <template #default="scope">
                  <el-button @click="handleDetailClick(scope.row)" type="text" size="small">
                      {{ $t("ORDERLIST.Detail") }}
                  </el-button>
                </template>
                </el-table-column>
              </el-table>
            </el-main>
            <el-footer style="margin: 1rem 2rem; background-color: #ffffff">
              <el-pagination style="float: right; margin: 1rem 0" background layout="total,sizes,prev, pager, next" 
              :page-sizes="[5, 10, 15, 20]" 
              :page-size="5"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange" 
              :total="totalCount" :current-page="Pageone">
              </el-pagination>
            </el-footer>
          </div>
        </div>
      </div>
      <!-- 添加活动 -->
      <el-dialog v-model="banners.dialogAddBanner" :title="$t('BANNERINFO.AddBANNER')"  class="dialog-two" :close-on-click-modal="false"  append-to-body width="90rem">
        <div class="add-banner-div">
            <el-button size="default" class="add-banner-btn" @click="uploadDocuments()">
          {{ $t("BANNERINFO.UPLOADFILEMSGBTN") }}
        </el-button>
        </div>
        <el-divider class="title-divider"></el-divider>
        <el-form :model="banners.bannerInfo" :inline="true" :rules="bannerRules" ref="banners.bannerInfo">
            <el-row :gutter="10" class="content_size" style="text-align: center;">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                    <el-form-item :label="$t('BANNERINFO.ACTIVITENAME')" prop="activiteName" class="form-label-field">
                        <el-input v-model="banners.bannerInfo.activiteName" autocomplete="off" class="myinput_inner myinput"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.STARTDATE')" class="form-label-field">
                        <el-date-picker type="date" v-model="banners.bannerInfo.startDate" placeholder="yyyy/mm/dd" class="myinput_inner"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.PAGETYPE')" prop="pageType" class="form-label-field">
                        <el-select v-model="banners.bannerInfo.pageType" class="myinput_inner" style="width:21rem">
                            <el-option v-for="item in pageTypeoptions" :key="item.key" :label="item.value" :value="item.key" ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.ENDDATE')" class="form-label-field">
                        <el-date-picker type="date" v-model="banners.bannerInfo.endDate" placeholder="yyyy/mm/dd" class="myinput_inner"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.REMARK')" class="form-label-field" prop="remark">
                        <el-input v-model="banners.bannerInfo.remark" autocomplete="off" class="myinput_inner" style="width: 67rem;"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.PCPICTUREURLCN')" class="form-label-field">
                        <el-input v-model="banners.bannerInfo.pcPictureUrlCn" autocomplete="off" class="myinput_inner" style="width: 67rem;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col class="col_msg">
                    <span v-html="$t('BANNERINFO.UPLOADPRICEMSG', {PriceWidth: 930 })" class="span_msg"></span>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.PCFILEURLCN')" class="form-label-field">
                        <el-input v-model="banners.bannerInfo.pcFileUrlCn" autocomplete="off" class="myinput_inner" style="width: 67rem;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col class="col_msg">
                    <span v-html="$t('BANNERINFO.UPLOADFILEMSG')" class="span_msg"></span>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.PCPICTUREURLEN')" class="form-label-field">
                        <el-input v-model="banners.bannerInfo.pcPictureUrlEn" autocomplete="off" class="myinput_inner" style="width: 67rem;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col class="col_msg">
                    <span v-html="$t('BANNERINFO.UPLOADPRICEMSG', {PriceWidth: 930})" class="span_msg"></span>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.PCFILEURLEN')" class="form-label-field">
                        <el-input v-model="banners.bannerInfo.pcFileUrlEn" autocomplete="off" class="myinput_inner" style="width: 67rem;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col class="col_msg">
                    <span v-html="$t('BANNERINFO.UPLOADFILEMSG')" class="span_msg"></span>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.H5PICTUREURLCN')" class="form-label-field">
                        <el-input v-model="banners.bannerInfo.h5PictureUrlCn" autocomplete="off" class="myinput_inner" style="width: 67rem;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col class="col_msg">
                    <span v-html="$t('BANNERINFO.UPLOADPRICEMSG', {PriceWidth: 640 })" class="span_msg"></span>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.H5FILEURLCN')" class="form-label-field">
                        <el-input v-model="banners.bannerInfo.h5FileUrlCn" autocomplete="off" class="myinput_inner" style="width: 67rem;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col class="col_msg">
                    <span v-html="$t('BANNERINFO.UPLOADFILEMSG')" class="span_msg"></span>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.H5PICTUREURLEN')" class="form-label-field">
                        <el-input v-model="banners.bannerInfo.h5PictureUrlEn" autocomplete="off" class="myinput_inner" style="width: 67rem;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col class="col_msg">
                    <span v-html="$t('BANNERINFO.UPLOADPRICEMSG', {PriceWidth: 640 })" class="span_msg"></span>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="content_size">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: center;">
                    <el-form-item :label="$t('BANNERINFO.H5FILEURLEN')" class="form-label-field">
                        <el-input v-model="banners.bannerInfo.h5FileUrlEn" autocomplete="off" class="myinput_inner" style="width: 67rem;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col class="col_msg">
                    <span v-html="$t('BANNERINFO.UPLOADFILEMSG')" class="span_msg"></span>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
        <div class="dialog-footer">
            <el-button type="warning" class="search-btn harpIDbtn" @click="saveAds()">{{$t("MESSAGE.CONFIRMBUTTONTEXT")}}</el-button>
            <el-button class="harpIDbtn" @click="banners.dialogAddBanner = false">{{$t("MESSAGE.CONFIRMCANCELTEXT")}}</el-button>
        </div>
        </template>
      </el-dialog>
      <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
      <BannerBind v-if="tabName == '2'"> </BannerBind>
    </div>
  </template>
  
  <script>
  import {saveAds,getAdsInfo }from "@/api/platformData";
  import { formatDateTime,hideElement } from "@/utils/utils.js";
  import ConfirmBoxs from "@/components/confirmBoxs.vue";
  import Loading from "@/components/Loading.vue";
  import Bannerheader from "@/views/bannerConfig/BannerHeader";
  import BannerBind from "@/views/bannerConfig/BannerBind";
  import Hbecountry from "@/views/HBEConfig/HBECountry";
  export default {
    name: "BannerMaintain",
    components: {
        ConfirmBoxs,
        Loading,
        Bannerheader,
        Hbecountry,
        BannerBind
    },
    data() {
      return {
        tabName: "1",
        bannertypeoptions: [
          { key: 0, value: "未开始",},
          { key: 1, value: "生效中",},
          { key: 2, value: "已结束",},
        ],
        pageTypeoptions: [
          { key: 0, value: "首页",},
          { key: 1, value: "国内机票",},
          { key: 2, value: "国际机票",},
          { key: 3, value: "国内酒店",},
          { key: 4, value: "国际酒店",},
          { key: 5, value: "火车",},
          { key: 6, value: "行程单",},
          { key: 7, value: "CRM",},
          { key: 8, value: "通用",},
        ],
        serachParams:{
          activiteCode: "",
          activiteName: "",
          startDate: "",
          activiteStatus: "",
          createdBy: "",
        },
        changeLoading: false,
        tableData: [],
        confirmMsg: "",
        confirmFlag: false,
        banners: {
          dialogAddBanner: false,
          bannerInfo: {
            activiteCode: "",//活动Code
            activiteName: "",//活动名称
            pageType: "",//页面类型
            activiteStatus: "",//活动状态
            startDate: "",//生效日期
            endDate: "",//结束日期
            remark: "",//备注
            pcPictureUrlCn: "",//PC中文图片地址
            pcPictureUrlEn: "",//PC英文图片地址
            pcFileUrlCn: "",//PC中文附件地址
            pcFileUrlEn: "",//PC英文附件地址
            h5PictureUrlCn: "",//h5中文图片地址
            h5PictureUrlEn: "",//h5英文图片地址
            h5FileUrlCn: "",//h5中文附件地址
            h5FileUrlEn: "",//h5英文附件地址
            },
        },
        totalCount: 0,
        bannerloading: false,
        Pageone: 1,
        pageSize: 5,
      };
    },
    mounted() {
        //-- CRM、OBT跳转处理 --
        //判断来源 CRM、OBT跳转过来隐藏部分元素
        hideElement(this);
    },
    computed: {
        bannerRules() {
            return {
              "activiteName": [{ required: true, message: this.$t("BANNERINFO.VALIDATEACTIVITENAME"), trigger: ["blur", "change"],},
                               { max: 50, message: this.$t("BANNERINFO.VALIDATELENGTH",{max : 50}), trigger: ["blur", "change"],}],
              "pageType": [{ required: true, message: this.$t("BANNERINFO.VALIDATEPAGETYPE"), trigger: ["blur", "change"], }],
              "remark": [{ max: 200, message: this.$t("BANNERINFO.VALIDATELENGTH",{max : 200}), trigger: ["blur", "change"],}],
            }
        },
    },
    methods: {
      //搜索button
        async adsSearch() {
            this.changeLoading = true;
            let searchparams = {
                activiteCode: this.serachParams.activiteCode,
                activiteName: this.serachParams.activiteName,
                startDate: this.serachParams.startDate? formatDateTime(this.serachParams.startDate, "YYYY-MM-DD"): null,
                createdBy: this.serachParams.createdBy,
                activiteStatus: this.serachParams.activiteStatus,
                pageRequest: {
                    page: this.Pageone,
                    per_page: this.pageSize,
                }
            };
            await getAdsInfo(searchparams)
            .then((res) => {
                if (res.code === 200) {
                    this.changeLoading = false;
                    this.tableData = [];
                    for (var i = 0; i < res.data.list.length; i++) {
                        var list = res.data.list[i];
                        const item = {
                            activiteName: list.activiteName,
                            activiteCode: list.activiteCode,
                            createdBy: list.createdBy,
                            pageType: list.pageType,
                            pageTypeValue: this.pageTypeoptions[list.pageType].value,
                            activiteStatus: this.bannertypeoptions[list.activiteStatus].value,
                            activiteStatusKey: list.activiteStatus,
                            createdDate: list.createdDate?formatDateTime(list.createdDate, "YYYY-MM-DD"): null,
                            startDate: list.startDate?formatDateTime(list.startDate, "YYYY-MM-DD"): null,
                            endDate: list.endDate?formatDateTime(list.endDate, "YYYY-MM-DD"): null,
                            remark: list.remark,
                            pcPictureUrlCn: list.advertise.hasOwnProperty("pcPictureUrlCn")? list.advertise.pcPictureUrlCn : null,
                            pcPictureUrlEn: list.advertise.hasOwnProperty("pcPictureUrlEn")? list.advertise.pcPictureUrlEn : null,
                            pcFileUrlCn: list.advertise.hasOwnProperty("pcFileUrlCn")? list.advertise.pcFileUrlCn : null,
                            pcFileUrlEn: list.advertise.hasOwnProperty("pcFileUrlEn")? list.advertise.pcFileUrlEn : null,
                            h5PictureUrlCn: list.advertise.hasOwnProperty("h5PictureUrlCn")? list.advertise.h5PictureUrlCn : null,
                            h5PictureUrlEn: list.advertise.hasOwnProperty("h5PictureUrlEn")? list.advertise.h5PictureUrlEn : null,
                            h5FileUrlCn: list.advertise.hasOwnProperty("h5FileUrlCn")? list.advertise.h5FileUrlCn : null,
                            h5FileUrlEn: list.advertise.hasOwnProperty("h5FileUrlEn")? list.advertise.h5FileUrlEn : null,
                        };
                        this.tableData.push(item);
                    }
                    this.totalCount= res.data.total;
                } else {
                this.changeLoading = false;
                this.confirmFlag = true;
                this.confirmMsg = res.message;
                this.deleteFlag = false;
                }
            })
            .catch(function (error) {
                console.log("酒店信息 请求失败", error.objError);
            });
        },
        setConfirmFlag(value) {
            this.changeLoading = false;
            this.confirmFlag = value;
        },
        addBanner(){
            this.banners.bannerInfo = {};
            this.banners.dialogAddBanner = true ;
        },
        //分页
        handleCurrentChange(pageNum) {
            this.Pageone = pageNum;
            this.adsSearch();
        },
        handleSizeChange(val){
            this.pageSize = val;
            this.adsSearch();
        },
        saveAds(){
            this.$refs["banners.bannerInfo"].validate((valid) => {
                if (valid) {
                    var startDate = this.banners.bannerInfo.startDate? formatDateTime(this.banners.bannerInfo.startDate, "YYYY-MM-DD"): null;
                    var endDate = this.banners.bannerInfo.endDate? formatDateTime(this.banners.bannerInfo.endDate, "YYYY-MM-DD"): null;
                    if(startDate !=null && endDate != null && startDate > endDate){
                        this.confirmMsg = this.$t("ORDERLIST.TIMECHECK");
                        this.confirmFlag = true;
                        return false;
                    }
                    let adsParam = {
                        activiteCode: this.banners.bannerInfo.activiteCode,
                        activiteName: this.banners.bannerInfo.activiteName,
                        pageType: this.banners.bannerInfo.pageType,
                        activiteStatus: this.updateActiviteStatus(),
                        startDate: startDate,
                        endDate: endDate,
                        createdBy: this.$objBaseInfo.loginID,
                        updateBy: this.$objBaseInfo.loginID,
                        remark: this.banners.bannerInfo.remark,
                        advertise: {
                            pcPictureUrlCn: this.banners.bannerInfo.pcPictureUrlCn,
                            pcPictureUrlEn: this.banners.bannerInfo.pcPictureUrlEn,
                            pcFileUrlCn: this.banners.bannerInfo.pcFileUrlCn,
                            pcFileUrlEn: this.banners.bannerInfo.pcFileUrlEn,
                            h5PictureUrlCn: this.banners.bannerInfo.h5PictureUrlCn,
                            h5PictureUrlEn: this.banners.bannerInfo.h5PictureUrlEn,
                            h5FileUrlCn: this.banners.bannerInfo.h5FileUrlCn,
                            h5FileUrlEn: this.banners.bannerInfo.h5FileUrlEn,
                        }
                    }
                    saveAds(adsParam)
                    .then((res) => {
                        if (res.code === 200) {
                            this.confirmFlag = true;
                            this.confirmMsg = this.$t("BANNERINFO.UPDATEADSSUCCESS");
                            this.banners.dialogAddBanner = false;
                            this.Pageone = 1;
                            //this.pageSize = 5;
                            this.adsSearch();
                        } else {
                            this.confirmFlag = true;
                            this.confirmMsg = this.$t("BANNERINFO.UPDATEADSFAIL");
                        }
                    })
                    .catch(function (error) {
                        console.log("保存广告信息 请求失败", error.objError);
                    });
                } else {
                    return false;
                }
            });
        },
        handleDetailClick(row){
            this.banners.bannerInfo = row;
            this.banners.dialogAddBanner = true ;
        },
        updateActiviteStatus(){
            var res = 0 ;
            var startDate = this.banners.bannerInfo.startDate? formatDateTime(this.banners.bannerInfo.startDate, "YYYY-MM-DD"): null;
            var endDate = this.banners.bannerInfo.endDate? formatDateTime(this.banners.bannerInfo.endDate, "YYYY-MM-DD"): null;
            var nowDate = formatDateTime(new Date(), "YYYY-MM-DD");
            if(startDate == null || endDate == null){
                res = 0;//未开始
            }else if (startDate > nowDate){
                res = 0;//未开始
            }else if (endDate < nowDate){
                res = 2;//已结束
            }else{
                res = 1;//生效中
            }
            return res;
        },
        childByValue(tab) {
            this.tabName = tab;
        },
        uploadDocuments(){
            // let link = document.createElement('a');
            // link.style.display = 'none';
            // link.href =;
            // link.click();
            window.open("https://roomit.mycwt.com.cn/filebrowser","_blank");
        }
    },
  };
  </script>
  
  <style lang="stylus" scoped>

  .pos_container_panel {
    padding: 0 4rem 0;
  }
  .harpIDbtn {
    width: 10rem;
    height: 3rem;
    padding: 0 !important;
    font-size: 1rem !important;
  }
  .form-label-field {
      font-size: 1.4rem;
      height: 3rem;
      line-height: 2rem;
      margin-top: 1.5rem;
  }
  .title-divider {
    margin-bottom: 1rem;
    margin-top: -1rem;
    height: 2px;
    background-color: $btn-bg-color;
  }
  .dialog-two {
    ::v-deep .el-dialog__body {
      padding: 3rem 0px 0px 0px;
    }

    .title-divider {
      margin-top: -1rem;
      height: 2px;
      background-color: $btn-bg-color;
    }
  }
  .content_size {
    margin-bottom: 1rem !important;
  }

  
  .myinput_inner /deep/ .el-input__inner {
    height: 2.7rem;
    border-radius: 0;
    /* margin-top: 1rem; */
  }
.myinput{
    padding-right: 17px;
}
.search-btn {
    margin: 2% 5%;
}
.span_msg{
    color: red;
}
.col_msg{
    margin-left: 8rem;
}
.add-banner-btn {
    padding: 8px 13px;
    background-color: $btn-bg-color;
    color: $btn-font-color;
    pointer-events: auto;
}
.add-banner-div {
    display: block;
    float: right;
    margin-right: 6%;
    margin-top: -3.5rem;
}
</style>
<style>
.el-tooltip__popper{
    max-width:50%;
}
</style>